import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authUser: {},
    isAuthenticated: false,
    jwt: localStorage.getItem('token'),
    endpoints: {
      obtainJWT: 'http://localhost:8888/api/token/',
      refreshJWT: 'http://localhost:8888/api/token/refresh/',
      baseURL: 'http://localhost:8888/api/'
    }

  },

  getters: {
    isAuthenticated(state) {
      return state.isAuthenticated;
    }
  },

  mutations: {
    setAuthUser(state, userStatus) {

      if(userStatus){
        Vue.set(state, 'authUser', userStatus.authUser)
        Vue.set(state,'isAuthenticated', userStatus.isAuthenticated)
      }else{
        Vue.set(state, 'authUser', null)
        Vue.set(state,'isAuthenticated', null)
      }

     
    },

    updateToken(state, newToken) {
      localStorage.setItem('token', newToken);
      state.jwt = newToken;
    },

    removeToken(state) {
      localStorage.removeItem('token');
      state.jwt = null;
    },

  },
  actions: {

      logout: function(context){
        context.commit("setAuthUser", {
          authUser: null,
          isAuthenticated: null
        });
      },

      refreshToken: async function(context){
        console.log("Refreshing token...");
        let tokenData = context.state.jwt;
        if (tokenData){
          var token = JSON.parse(tokenData);
          var newAccessToken;
          let payload = {
            refresh: token.refresh
          }
          let refreshed = await axios.post(context.state.endpoints.refreshJWT, payload).then((response) => {
              console.log("Refresh successful", response.data);
              if(response.data.access){
                token.access = response.data.access;
                context.commit('updateToken', JSON.stringify(token));
              }

              return true;
              
          })
          .catch((error) => {
              console.log("Refresh failed");
              return false;
          })

          return refreshed;
        }

        return false;
      },

      getAPIResource: async function(context, apiRequest){
          let tokenData = context.state.jwt;
          if (tokenData){
            let token = JSON.parse(tokenData);

            axios.defaults.headers.common['Authorization'] = 'Bearer '+token.access;

            let results = await axios.get(context.state.endpoints.baseURL + apiRequest.resource).then((response) => {
              console.log("Success");  
              
              return response;
            })
            .catch((error) => {
            
              if(error.response){
                console.log("ERROR", error.response.status);
                if(error.response.status && error.response.status == 401){
                  
                  if(!apiRequest.refresh){
                    console.log("Unauthorizied token, try refreshing");
                    apiRequest.refresh = true;
                    context.dispatch('refreshToken').then((refreshed) => {
                      if(refreshed){
                        console.log("refreshed");
                      }
                    })
                    
                
                  }
                  
                }
                return error.response;
              }

              return null;
              
            })

            return results;
          }else{
            console.log("No auth token");
            return false;
          }
          
      }
  }
})
